<template>
  <div class="myUpload">
    <a-upload-dragger
      v-model:fileList="fileList"
      name="uploadFile"
      :multiple="false"
      :showUploadList="false"
      :accept="accept"
      :maxCount="props.maxCount"
      action="/upload/cloud/file/upload"
      @change="handleChange"
      @drop="handleDrop"
      @progress="handleProgress"
      :beforeUpload="beforeUpload"
    >
      <p class="ant-upload-text" v-if="!assessStatus">请上传完善好的文件</p>
      <p class="ant-upload-text" style="margin-bottom: 28px;" v-else><div class="item"><FileTextOutlined />评估报告.xls</div></p>
      <p class="ant-upload-drag-icon" v-if="!assessStatus">
        <inbox-outlined></inbox-outlined>
      </p>
      <span class="btn-upload">选择文件</span>
      <!-- <p class="ant-upload-hint">单击或拖动文件到此区域进行上传</p> -->
    </a-upload-dragger>
    <div class="myProcess" v-if="file">
      <a-spin :indicator="indicator" v-if="uploading" />
      <CloseCircleFilled
        style="font-size: 66px; color: #ff5353"
        v-if="!result && !uploading"
      />
      <CheckCircleFilled
        style="font-size: 66px; color: #186ff2"
        v-if="result && !uploading"
      />
      <div class="info">
        <a-progress
          stroke-linecap="square"
          :percent="uploadProgress"
          :status="processStatus"
          :size="4"
          class="posibar"
          v-if="uploading"
        />
        <div class="flex">
          <span> {{ file }} </span> <span> {{ code }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {
  ref,
  onMounted,
  reactive,
  watch,
  nextTick,
  defineExpose,
  onUnmounted,
  h,
  defineProps,
  defineEmits,
} from "vue";
import { LoadingOutlined,FileTextOutlined } from "@ant-design/icons-vue";
import { message, Upload } from "ant-design-vue";
import { uploadOneFile } from "@/api/upload.js";

const props = defineProps({
  pathName: {
    type: String,
    default: "",
  },
  // .doc, .docx, .jpeg, .jpg, .png, .xls, .xlsx
  accept: {
    type: String,
    default: "",
  },
  maxCount: {
    type: Number,
    default: 1,
  },
  updateTitle: {
    type: String,
    default: "上传",
  },
  // 评估报告上传 样式不一样 需要区分
  assessStatus: {
    type: Boolean,
    default: false,
  },
});

const fileList = ref([]);
const uploadProgress = ref(100);
let processStatus = ref("");
let uploading = ref(false);
let result = ref(false);
let file = ref();
let code = ref();
const indicator = h(LoadingOutlined, {
  style: {
    fontSize: "66px",
  },
  spin: true,
});

const handleChange = (info) => {
  const status = info.file.status;
  file.value = info.file.name;
  uploading.value = true;
  if (status !== "uploading") {
    console.log(info.file, info.fileList);
  }
  if (status === "done") {
  } else if (status === "error") {
    message.error(`${info.file.name} file upload failed.`);
    code.value = "上传失败";
    result.value = false;
    processStatus.value = "exception";
    uploading.value = false;
  }
};

let timer = ref(null);
const handleProgress = (progressEvent) => {
  processStatus.value = "active";
  const complete = (progressEvent.loaded / progressEvent.total) * 100;

  // 超过80 开始干涉
  if (complete >= 80) {
    if (timer.value) return;
    timer.value = setInterval(() => {
      uploadProgress.value += (100 - uploadProgress.value) * 0.2; // 每次增加剩下的20%

      // 超过95 不再变化（此时也接近上传完成了）
      if (uploadProgress.value > 95) {
        timer.value && clearInterval(timer.value);
      }
    }, 1000);
  } else {
    // 在80之前都按照axios计算出的进度来显示
    uploadProgress.value = complete;
  }
};

function handleDrop(e) {
  console.log(e);
}

const emits = defineEmits(["uploadFinished"]);

// 文件体转化
const convertFormData = (data) => {
  let folder = Date.now().toString();
  const json = {
    bucketName: "testing-management-private",
    pathName: props.pathName+'/'+folder, // 上传服务器路径，以项目模块名定义 如 test_project test_task
  };
  console.log(json);
  const formData = new FormData();
  formData.append("uploadFile", data);
  formData.append(
    "json",
    new Blob([JSON.stringify(json)], { type: "application/json" })
  );
  return formData;
};

const beforeUpload = (file, fileList) => {
  if (props.accept !== "") {
    const docsArr = props.accept?.split(",");
    const fileType = file.name.split(".");
    const fileDate = fileType.slice(-1);
    if (!docsArr.includes(`.${fileDate[0]}`)) {
      message.error(`仅支持${props.accept}文件格式！`);
      return Upload.LIST_IGNORE;
    }
  }
  uploadOneFile(convertFormData(file), (progressEvent) =>
    handleProgress(progressEvent)
  ).then((res) => {
    console.log(res);
    if (res.code === 200) {
      emits("uploadFinished", res.data);
      message.success(`上传成功`);
      code.value = "上传完成";
      result.value = true;
      uploading.value = false;
    }
  });

  return false;
};

function reset() {
  file.value = null;
  code.value = "";
  result.value = false;
}

onUnmounted(() => {
  reset();
});

defineExpose({
  reset,
});
</script>

<style scoped lang="less">
.myUpload {
  position: relative;
}
.btn-upload {
  display: inline-block;
  font-size: 14px;
  color: #636d7b;
  width: 100px;
  height: 32px;
  cursor: pointer;
  line-height: 32px;
  background: #ffffff;
  border-radius: 4px 4px 4px 4px;
  border: 1px solid #636d7b;
}
.myProcess {
  position: absolute;
  top: 0px;
  left: 0;
  width: 100%;
  z-index: 55;
  height: 163px;
  text-align: center;
  padding-top: 15px;
  background: #f6f8fa;
  border-radius: 4px 4px 4px 4px;

  .info {
    border-top: 1px solid #e1e7ef;
    border-bottom: 1px solid #e1e7ef;
    margin-top: 28px;
    padding: 15px 0px;
    position: relative;

    /deep/.posibar {
      position: absolute;
      top: -11px;
      left: 0;

      .ant-progress-text {
        display: none;
      }

      .ant-progress-outer {
        margin-inline-end: auto !important;
        padding-inline-end: 0 !important;
      }
    }

    .flex {
      display: flex;
      justify-content: space-between;
      padding: 0 15px;
    }
  }
}
.item {
      color: #636d7b;
      font-size: 14px;

      .anticon {
        color: #186ff2;
        margin-right: 13px;
      }
    }
</style>
